import { Controller } from '@hotwired/stimulus';

export default class PageAnalyticsController extends Controller {
  static values = { event: String, data: Object };
  declare eventValue: string;
  declare hasDataValue: boolean;
  declare dataValue: Record<string, unknown>;

  static track(eventName: string, data: object = {}): void {
    window.gtag('event', eventName, data);
    window.umami?.track(eventName, data);
  }

  connect(): void {
    // Don't fire events twice when coming back to cached pages
    if (document.documentElement.hasAttribute('data-turbo-preview')) return;

    if (!this.hasDataValue) return;
    PageAnalyticsController.track(this.eventValue, this.dataValue);
  }
}
